import { Chip, capitalize } from '@mui/material';
import { FC } from 'react';
import { RecipeFragment_Recipe_recipeTags_RecipeTag } from '../../../../__generated__/queries-recipe';
import { useStyles } from './styles';

interface TagsProps {
  recipeTags: RecipeFragment_Recipe_recipeTags_RecipeTag[];
  setRecipeTags?: (tags: RecipeFragment_Recipe_recipeTags_RecipeTag[]) => void;
}

export const Tags: FC<TagsProps> = ({ recipeTags, setRecipeTags }) => {
  const classes = useStyles();
  return (
    <div className={classes.tags}>
      {recipeTags
        .filter(({ tag }) => !!tag)
        .map(({ id, tag }, i) => {
          return (
            <Chip
              key={i}
              className={classes.tag}
              variant="outlined"
              label={capitalize(tag?.title || '')}
              onDelete={() => {
                setRecipeTags &&
                  setRecipeTags([
                    ...recipeTags.map((recipeTag) => ({
                      ...recipeTag,
                      tag: recipeTag.id === id ? null : recipeTag.tag,
                    })),
                  ]);
              }}
            />
          );
        })}
    </div>
  );
};
